import { UpperCasePipe } from '@angular/common';
import { Component, inject, linkedSignal, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserDataService } from '../../services/user-data.service';
import { RegisteredSerial } from '../../models/registered-serial';
import { RegisteredSerialsService } from '../../services/registered-serials.service';
import { filter, repeat, take } from 'rxjs';
import dayjs from 'dayjs';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { Modal, ModalDismissReasons } from '../../services/modal.service';

@Component({
  selector: 'modal-warranty-ok',
  imports: [TranslatePipe, UpperCasePipe, FormatDatePipe],
  templateUrl: './warranty-ok.component.html',
  styleUrls: ['./warranty-ok.component.scss']
})
export class WarrantyOKComponent implements OnInit {

  private modal = inject(Modal);
  private userDataService = inject(UserDataService);
  private registeredSerialsService = inject(RegisteredSerialsService);

  registeredSerial = signal<RegisteredSerial | null>(null);
  termDate = signal<string>('');

  email = linkedSignal(() => this.userDataService.user()?.email ?? '');

  ngOnInit(): void {
    this.refresh();
  }

  private refresh() {
    this.registeredSerialsService.getRegisteredSerial(this.modal.params.selectedId).pipe(
      repeat({
        delay: 1000
      }),
      filter(data => data.warrantyRequestDate !== null),
      take(1)
    ).subscribe({
      next: data => {
        this.registeredSerial.set(data);
        this.refreshTrainerName();
        let purchaseDate = dayjs(data.purchaseDate);
        purchaseDate = purchaseDate.add(data.warrantyYears, 'year');
        this.termDate.set(purchaseDate.toISOString());
      }
    });
  }

  private refreshTrainerName() {
    const trainers = this.userDataService.trainers();
    const registeredSerial = this.registeredSerial()
    if (!registeredSerial) {
      return;
    }
    const index = trainers.findIndex(t => {
      return t.code === registeredSerial.trainerCode;
    });
    if (index != -1) {
      registeredSerial.trainerName = trainers[index].name;
    } else {
      registeredSerial.trainerName = '-';
    }
    this.registeredSerial.set(registeredSerial);
  }

  close() {
    this.modal.dismiss(ModalDismissReasons.OK);
  }
}
